import AdvanceGroupAssignmentDetails from './AdvanceGroupAssignmentDetails';

export default AdvanceGroupAssignmentDetails;
